import React, {PureComponent, ReactNode} from "react"
import ReactDOM from "react-dom"
import {Manager, Reference, Popper} from "react-popper"

import id from "@irati/utils/id"

import DropdownOverlay from "./DropdownOverlay"

import {InnerRefWrapper, RefWrapper, StyledHr, ToggleButton} from "./styled/DropdownOverflow"

interface Props {
  pullRight?: boolean,
  header?: ReactNode,
  footer?: ReactNode,
  children: ReactNode,
  iconColor?: string,
  icon?: string,
  disabled?: boolean,
  width?: number,
  onToggle?: (open: boolean) => void,
  id?: string
}

interface State {
  open: boolean
}

class Dropdown extends PureComponent<Props, State> {
  static defaultProps = {
    pullRight: false,
    header: null,
    footer: null,
    iconColor: null,
    icon: "filter",
    disabled: false
  }

  toggleRef = React.createRef<any>()

  state: State = {
    open: false
  }

  toggle = () => {
    const {disabled, onToggle} = this.props

    if (onToggle) {
      onToggle(!this.state.open)
    }
    if (!disabled) {
      this.setState({open: !this.state.open})
    }
  }

  close = () => this.setState({open: false})

  render() {
    const {header, footer, children, iconColor, icon, width} = this.props
    const idNamespace = id("DropdownOverlay", this.props)
    const {open} = this.state

    return (
      <Manager>
        <RefWrapper ref={this.toggleRef}>
          <Reference>
            {({ref}) => (
              <RefWrapper ref={ref}>
                <ToggleButton onClick={this.toggle} open={open} slim icon={icon!} id={idNamespace} color={iconColor} />
              </RefWrapper>
            )}
          </Reference>
        </RefWrapper>
        {open &&
          ReactDOM.createPortal(
            <Popper placement="bottom-start">
              {({placement, ref, style}) => {
                return (
                  <InnerRefWrapper ref={ref} style={style} data-placement={placement}>
                    <DropdownOverlay onClickOutside={this.toggle} toggleRef={this.toggleRef} width={width}>
                      <span>
                        {header && (
                          <>
                            {" "}
                            {header} <StyledHr top />{" "}
                          </>
                        )}
                        {children}
                        {footer && (
                          <>
                            {" "}
                            <StyledHr /> {footer}{" "}
                          </>
                        )}
                      </span>
                    </DropdownOverlay>
                  </InnerRefWrapper>
                )
              }}
            </Popper>,
            document.body
          )}
      </Manager>
    )
  }
}

export default Dropdown
